import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CheckCircleRoundedIcon from "@mui/icons-material/CheckCircleRounded";
import "./registrationSuccess.css";

import VerifiedIcon from "@mui/icons-material/Verified";

export default function RegistrationSuccess() {
  const navigate = useNavigate();
  const [seconds, setSeconds] = useState(9);

  useEffect(() => {
    if (seconds === 0) {
      navigate("/access/client-portal/authentication/sign-in");
      return;
    }

    const timer = setTimeout(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);

    return () => clearTimeout(timer);
  }, [seconds, navigate]);

  return (
    <div className="registered-success-wrapper fx-ac fx-jc">
      <div className="registration-success-container">
        <div className="registration-success-card fs6 fx-cl space3 fx-ac fx-jc">
          <VerifiedIcon
            sx={{
              fontSize: 90,
              color: "#22c55e",
            }}
          />

          <h1 className="fw500">Registration Successful</h1>
          <div className="fx-cl spacem">
            <p className="fs6 fw300">
              Congratulations! Your company registration has been completed
              successfully.
            </p>

            <p className="fs5 fw500">
              You will be redirected automatically in{" "}
              <strong>
                {seconds} second{seconds !== 1 ? "s" : ""}.
              </strong>
            </p>
          </div>

          <button
            className="registered-success-btn fs3 fw400"
            onClick={() =>
              navigate("/access/client-portal/authentication/sign-in")
            }
          >
            Let's go!
          </button>
        </div>
      </div>
    </div>
  );
}
